import React from 'react';
import { StatusBadge } from '../../components/common/StatusBadge';

const AccountStatus = (props) => {
  // Determine the color variant based on account status
  const colorVariant = props.value === 'deleted' ? 'neutral' : 'success';
  
  return (
    <StatusBadge 
      label={props.value} 
      colorVariant={colorVariant} 
      capitalize={true} 
    />
  );
};

export default AccountStatus;
